module.exports = __webpack_public_path__ + "d2d88c3fbf8031128ac90d1ede37fc51.svg";